import { render, staticRenderFns } from "./SkillCard.vue?vue&type=template&id=25d624b3"
import script from "./SkillCard.vue?vue&type=script&lang=js"
export * from "./SkillCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports